module.exports = __webpack_public_path__ + "img/face-smile-beam.c78ef02f.svg";